import { Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledPaper = styled(Paper)({
  boxShadow: `8px 5px 20px -5px rgba(0,0,0,0.1)`,
  borderRadius: '1rem',
});
